import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';
import { DiscountCodeAuthorizerProptype } from '../proptypes/DiscountCodeAuthorizerProptypes';

const DiscountCodeAuthorizerBasicInformationResource = ({
  discountCodeAuthorizer,
}) => {
  const { customer, active, createDate } = discountCodeAuthorizer || {};

  return (
    <>
      <ResourceProperty label="Nombre:">
        {customer.fullName || '-'}
      </ResourceProperty>
      <ResourceProperty label="Estado:">
        {active ? 'Activo' : 'Inactivo'}
      </ResourceProperty>
      <ResourceProperty label="Fecha de Creación:">
        {tzNormalizeDate({ date: createDate, format: DATE_FORMAT }) || '-'}
      </ResourceProperty>
    </>
  );
};

DiscountCodeAuthorizerBasicInformationResource.propTypes = {
  discountCodeAuthorizer: DiscountCodeAuthorizerProptype,
};

DiscountCodeAuthorizerBasicInformationResource.defaultProps = {
  discountCodeAuthorizer: null,
};

export default DiscountCodeAuthorizerBasicInformationResource;
